import { render, staticRenderFns } from "./TheNotifications.vue?vue&type=template&id=a9d10a86&scoped=true"
import script from "./TheNotifications.vue?vue&type=script&lang=js"
export * from "./TheNotifications.vue?vue&type=script&lang=js"
import style0 from "./TheNotifications.vue?vue&type=style&index=0&id=a9d10a86&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a9d10a86",
  null
  
)

export default component.exports